import { cn } from '../../lib/utils';

/**
 * Standardowy header strony — używaj w każdym top-level page'u zamiast inline'owego h1+p.
 *
 * Props:
 *  - title:    string | ReactNode
 *  - subtitle: string | ReactNode (opcjonalny)
 *  - badge:    ReactNode obok tytułu (np. <Badge variant="success" dot>Live</Badge>)
 *  - action:   ReactNode w prawym rogu (przyciski, search, refresh)
 *  - children: dodatkowy content pod subtitle (filtry, breadcrumbs)
 */
export default function PageHeader({
  title,
  subtitle,
  badge,
  action,
  children,
  className,
}) {
  return (
    <div className={cn('flex items-start justify-between gap-4 mb-7 flex-wrap', className)}>
      <div className="min-w-0 flex-1">
        <h1 className="text-2xl lg:text-3xl font-bold text-ink-900 dark:text-ink-50 tracking-tighter flex items-center gap-3 flex-wrap">
          {title}
          {badge}
        </h1>
        {subtitle && (
          <p className="text-sm text-ink-500 dark:text-ink-400 mt-1.5 max-w-2xl text-pretty">
            {subtitle}
          </p>
        )}
        {children}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
